import pluck from 'ramda/src/pluck';
export var GRACE_PERIOD_TYPE = {
  SUBSCRIBER_PRODUCT: 1,
  ORDER: 2
};
export var getOrderIdAndSubscriberProductIds = function getOrderIdAndSubscriberProductIds() {
  var offer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isOrderPaymentFailure = offer.Options.some(function (option) {
    return option.OffCycleDetail && option.OffCycleDetail.CurrentRenewalFailedAttempts && option.OffCycleDetail.GracePeriodExpiryDate && option.OffCycleDetail.GracePeriodType === GRACE_PERIOD_TYPE.ORDER;
  });
  if (isOrderPaymentFailure) {
    return {
      orderId: offer.OrdersPendingPayment[0]
    };
  } else {
    var subscriberProductIds = pluck('SubscriberProductId', offer.Options.filter(function (option) {
      return option.OffCycleDetail && option.OffCycleDetail.CurrentRenewalFailedAttempts && option.OffCycleDetail.GracePeriodExpiryDate && option.OffCycleDetail.GracePeriodType === GRACE_PERIOD_TYPE.SUBSCRIBER_PRODUCT;
    }));
    return {
      subscriberProductIds: subscriberProductIds
    };
  }
};